const ADMIN_ROLES = new Set(['admin', 'hyperadmin', 'super_admin', 'store_admin']);
const PRIVATE_STATES = new Set(['ended_early', 'contract_ended_early']);
const PRIVATE_LABEL_KEYS = new Set(['contract_status', 'status', 'status_label', 'contract_status_label', 'note', 'notes', 'reason', 'document_url']);

export const canViewEarlyTermination = role => ADMIN_ROLES.has(role);

// Defense for stale responses/profile cache; the API is the security boundary.
export const contractDataForViewer = (value, role) => {
  if (canViewEarlyTermination(role) || value === null || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(item => contractDataForViewer(item, role));
  const privateStatus = PRIVATE_STATES.has(value.contract_status) || PRIVATE_STATES.has(value.status);
  const legacyEarlyDate = value.days?.some?.(day => PRIVATE_STATES.has(day.contract_status));
  return Object.fromEntries(Object.entries(value).filter(([key]) =>
    !key.startsWith('early_termination') &&
    !(privateStatus && PRIVATE_LABEL_KEYS.has(key)) &&
    !(legacyEarlyDate && key === 'contract_end_date')
  ).map(([key, item]) => [key, contractDataForViewer(item, role)]));
};